var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticClass:"grey darken-4 fill-height py-4",attrs:{"app":""}},[_c('v-container',{staticClass:"px-8 pt-0 ",attrs:{"fluid":"","fill-height":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }